// quotationValidationSchema.js
import * as Yup from 'yup';

export const initialValues = {
  pid: '',
  party_name: '',
  party_mob: '',
  party_state: 'Maharashtra',
  party_city: '',
  party_pinCode: '',
  party_address: '',
  quote_no: "",
  quote_date: "",
  quote_type: "quotation",
  quote_status: 0,
  sub_total: 0,
  discount: 0,
  gst_percent: 0,
  s_gst: 0,
  c_gst: 0,
  grand_total: 0,
  paid_amount: 0,
  balance_amount: 0,
  login_id: 0,
  details: [
    {
      quote_id: 0,
      item_main_id: 0,
      item_sub_id: 0,
      item_id: 0,
      item_name: "",
      item_hsn: "0",
      item_size: "",
      item_qty: 0,
      item_mrp: '',
      item_rate: 0,
      item_amount: '',
    }
  ]
};

export const quotationValidationSchema = Yup.object().shape({
  party_name: Yup.string().required("Party Name is required"),
  party_mob: Yup.string()
    .trim()
    .matches(/^\d{10}$/, "Enter a valid 10-digit mobile number")
    .required("Mobile is required"),
  party_address: Yup.string().trim().required("Address is required"),
  party_state: Yup.string().trim().required("State is required"),
  party_city: Yup.string().trim().required("City is required"),
  party_pinCode: Yup.string()
    .trim()
    .matches(/^\d{6}$/, "Enter a valid 6-digit pincode")
    .required("Pincode is required"),
  
  details: Yup.array().of(
    Yup.object().shape({
      item_name: Yup.string().trim().required("Particular is required"),
      // item_hsn: Yup.string().trim().required("HSN is required"),
      item_size: Yup.string().trim().required("Size is required"),
      item_qty: Yup.number()
        .typeError("Qty must be a number")
        .positive("Qty must be positive")
        .required("Qty is required"),
      item_rate: Yup.number()
        .typeError("Rate must be a number")
        .positive("Rate must be positive")
        .required("Rate is required"),
    })
  )
});
